function initStateFilter() {
    const STATES_TO_HIDE = new Set(["AR", "ID", "MN", "RI", "OR"]);

    function removeUnwantedStates() {
        const stateSelect = document.getElementById("state-field");
        if (!stateSelect) return;

        [...stateSelect.options].forEach(option => {
            if (STATES_TO_HIDE.has(option.value)) {
                option.remove();
            }
        });
    }

    const stateSelect = document.getElementById("state-field");

    if (stateSelect) {
        new MutationObserver(removeUnwantedStates).observe(stateSelect, {
            childList: true
        });

        removeUnwantedStates();
    }
}

setTimeout(() => {
    initStateFilter();
}, 3000);